export default __webpack_public_path__ + "static/media/CoulombLogo.354c5332.svg";